import { useState, useEffect } from 'react';
import { useErrorReporter } from '@wix/cli-error-reporting';
import { createVeloCLIServer } from '@wix/editor-velo-cli-comm-api';

export function useWebSocketServer() {
  const { reportError } = useErrorReporter();
  const [server] = useState(() => createVeloCLIServer());

  useEffect(() => {
    return () => {
      server.close().catch(reportError);
    };
  }, [server, reportError]);

  return server;
}
